import { render, staticRenderFns } from "./AddCompatibleWith.vue?vue&type=template&id=21f5a996&"
import script from "./AddCompatibleWith.vue?vue&type=script&lang=js&"
export * from "./AddCompatibleWith.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports